import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../'

const { env } = window

/** POST or PUT to save or update full affiliation data */
const useSaveAffiliationMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { tenant } = useTenant()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const saveAffiliation = async (data) => {
    const url = encodeURI(
      data.id
        ? `${env.apiUrl}/affiliations/${data.id}`
        : `${env.apiUrl}/tenants/${tenant.id}/affiliations`
    )
    const response = await securedFetch(url, {
      method: data.id ? 'PUT' : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    await handleResponse(response)
    return response.json()
  }

  return useMutation({
    mutationFn: ({ data }) => saveAffiliation(data),
    onMutate: ({ data }) => {
      progressStart()
      if (data.id) {
        queryClient.cancelQueries('admin-categories')
        queryClient.setQueryData(['admin-categories', data.id], data.categories)
      }
    },
    onError: (error) => handleError(error, 'Error saving group'),
    onSuccess: (_, variables) => {
      const { data } = variables
      setMessage(
        `The group '${data.name}' was ${data.id ? 'updated' : 'created'}`
      )
      queryClient.invalidateQueries('affiliations')
      queryClient.invalidateQueries('admin-affiliations')
      queryClient.invalidateQueries('categories')
      queryClient.invalidateQueries('admin-categories')
    },
    onSettled: progressEnd
  })
}

export { useSaveAffiliationMutation }
